// extracted by mini-css-extract-plugin
module.exports = {"boardContainer":"Board_boardContainer__3D6TJ"};